define('viewmodels/Reporting/WordReport',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger', 'services/utils'], function (ko, router, appsecurity, navigation, app, system, logger, utils) {

    var RmViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        utils: utils,
        ClickUploaddocument: ClickUploaddocument,
        popUpTitle: ko.observable(),
        EditUserDetails: ko.observable(true),
        getoptions: getoptions,
        DocumentTypeList: ko.observableArray(),
        DocumentTypeListDup: ko.observableArray(),
        ControlsAccess: ko.observable(false),
        addPopUpCss: ko.observable(),
        valuedoctype: ko.observable(),
        FolderName: ko.observable(),
        UploadDocument: UploadDocument,
        comments: ko.observable(),
        UploadReportDetails: UploadReportDetails,
        YearofAssessment: ko.observable(),
        YearChanged: YearChanged,
        docpath: ko.observable(),
        ReportDetailsList: ko.observableArray(),
        EditReportPopUp: EditReportPopUp,
        EditDocumentDetails: ko.observableArray(),
        LowestOptionSprocList: ko.observableArray(),
        LowestOptionList: ko.observableArray(),
        Optionvaluedoctype: ko.observable(),
        CurrentYear: ko.observable(),
        BuListReport: BuListReport,
        ReportModelCount: ko.observable(0),
        DownloadReport: DownloadReport,
        DeleteReportPopUp: DeleteReportPopUp,
        Savedisabled: ko.observable(true),
        UploadFileSize: ko.observable(3145728),
        CurrentProfile: ko.observable(),
        SaveDocument: SaveDocument,
        //YearofAssessmentList: ko.observableArray(),
        ProfileofAssessmentList: ko.observableArray(),
        SrNo: ko.observable(0),
        AssessmentList: ko.observableArray([]),
        ApplicableAssessmentList: ko.observableArray([]),
        SelectedAssessmentId: ko.observable(),
        OpenDownloadSummaryReportpopup: OpenDownloadSummaryReportpopup,
        OpenDownloadSummaryReportpopupS02: OpenDownloadSummaryReportpopupS02,
        GetBusinessUnitByBusinessLevel: GetBusinessUnitByBusinessLevel,
        FillSubOrgLevel: FillSubOrgLevel,
        BusinessUnitsList: ko.observableArray(),
        DownloadWordReport: DownloadWordReport,
        SelectedOrgLevelId: ko.observable([]),
        SelRiskAssessmentName: ko.observable(),
        OrgLvlDrpDwnList: ko.observableArray(),
        SelectedProfileHistoricalAssessment: ko.observable(),
        ShowNarrativeReportsMainList: ShowNarrativeReportsMainList,
        Clnt: ko.observable(),
        OrganisationalLevelList: ko.observableArray(),
        Overrides_Show: ko.observable(true),
        IsBU: ko.observable(true),
        SelectedProfileOfAssessmentS01: ko.observable(null),
        SelectedProfileOfAssessmentS02: ko.observable(null),
        FillOrgLevel: FillOrgLevel,
        BusinessLevelValueList: ko.observableArray(),
        SelectedBuUnitsID: ko.observable([])
    };
    return RmViewModel;

    var UserTableObj = false;



    function activate() {
        try {
            //   RmViewModel.EditDocumentDetails(new ReportDetailsModel({ DocumentType: '', DocumentUploadedforYear: '', DocumentComments: "", DocumentPath: "" }));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {

            if (appsecurity.WriteAccess()) {
                RmViewModel.ControlsAccess(true);
            }
            else {
                RmViewModel.ControlsAccess(false);
            }
            ShowNarrativeReportsMainList();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }
    function ShowNarrativeReportsMainList()
    {
        try {
            return $.ajax({
                url: "/api/Configuration/GetTableIdNarrativeReport",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != null && jsonResult.length > 0) {
                        RmViewModel.Clnt(jsonResult);
                    }
                    if (jsonResult == 'S01') {
                        getS01ReportDetails();
                    }
                    if (jsonResult == 'S02') {                        
                    }
                })
                .fail(function (jsonResult, error) {
                    $("#tblReportDetailsS01").hide();
                    $("#tblReportDetailsS02").hide();
                    logger.logError('An error occured while fetching the Narrative Reports for this client.', 'Error', system.getModuleId(RmViewModel), true);
                });
        }
        catch (e) {
        var msg = 'Exception: ' + e + ' | Source: attached() method in Reports.js';
        logger.logMessage(msg);
    }
    }
    function FillOrgLevel() {
        try {
            GetOrgLevel();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in FillOrgLevel() method in Report.js';
            logger.logMessage(msg);
        }
    }
    function GetOrgLevel() {
        try {
            return $.ajax({
                url: "/api/Configuration/getAllBusinessLevelsDocReport",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { TypeId: RmViewModel.SelectedProfileOfAssessmentS02() }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetOrgLevel() method in Reports.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var OrganizationalLevels = $.map(jsonResult, function (result) {
                        return new OrganisationLevelModelReport(result);
                    });
                    if (OrganizationalLevels.length > 0) {
                        RmViewModel.OrganisationalLevelList(OrganizationalLevels);
                        BuListReport();
                    }
                    else {
                    }

                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
    }   
    function OrganisationLevelModelReport(item) {
        try {
            var self = this;
            self.OrganisationLevelId = ko.observable($('<div/>').html(item.BuLId).text());
            self.OrganisationLevelName = ko.observable($('<div/>').html(item.BuLevelName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OrganisationLevelModel() method in Reports.js';
            logger.logMessage(msg);
        }
    }
    function GetAllOrganizationalLevels() {
        try {
            return $.ajax({
                url: "/api/Configuration/getDistinctBusinessLevelsAllBUApplicability",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { TypeId: RmViewModel.SelectedAssessmentId(), YOA: RmViewModel.SelectedProfileOfAssessmentS02() }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in Report.js';
            logger.logMessage(msg);

        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var OrganizationalLevels = $.map(jsonResult, function (result) {
                        return new BusinessLevelsModel(result);
                    });
                    if (OrganizationalLevels.length > 0) {
                        RmViewModel.OrgLvlDrpDwnList(OrganizationalLevels);
                    }
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
    }
    function BuLevelValueListModel(item) {
        try {
            var self = this;
            self.BlvalueId = ko.observable($('<div/>').html(item.BlvalueId).text());
            self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
            self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
            self.BlvalueShortName = ko.observable($('<div/>').html(item.BlvalueShortName).text());
            self.TargetRow = ko.observable(item.TargetRow);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in Report.js';
            logger.logMessage(msg);
        }
    }

    function BusinessLevelsModel(item) {
        try {
            var self = this;
            self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
            self.BlName = ko.observable($('<div/>').html(item.BlName).text());
            self.BlId = ko.observable(item.BlId)
            var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                return new BuLevelValueListModel(result);
            });
            self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in Report.js';
            logger.logMessage(msg);
        }
    }
    function getAllBusinessUnits() {
        try {
            return $.ajax({
                url: "/api/Reporting/GetAllBusinessUnitsByProfileAssessment?profileId=" + RmViewModel.SelectedProfileOfAssessmentS01(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in report.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResultObj, status) {

            try {

                if (jsonResultObj != 'undefined' && jsonResultObj != null && jsonResultObj != "") {

                    RmViewModel.BusinessUnitsList([]);
                    var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                        return new BusinessUnitsModel(result);
                    });

                    RmViewModel.BusinessUnitsList(mappedBusinessUnits);

                    $('#BUSelector').multiselect();
                    $('#BUSelector').multiselect("refresh");
                    $(".ui-multiselect-checkboxes > li > label > span").addClass("cc-facet-result-text tag-text");
                    //$(".ui-multiselect-checkboxes > li > label").addClass("cc-checkbox");
                    //  $(".ui-multiselect-checkboxes > li > label > span").addClass("cc-facet-result-text tag-text");
                }
                else {
                    app.showMessage("Business Units configurations not in place", "Error", ["OK"]);

                    RmViewModel.BusinessUnitsList([]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllBusinessUnits() method in ValidationReports.js';
                logger.logMessage(msg);
            }

        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in ValidationReports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        };
    }
    function BuListReport() {
        try {
            var mappedBuList = [];
            if (RmViewModel.SelectedOrgLevelId() == 0) {
                $('#BUSelector').multiselect();
                $('#BUSelector').multiselect("refresh");
                RmViewModel.IsBU(true);
                RmViewModel.BusinessUnitsList([]);
                getAllBusinessUnits();

            }
            else {
                RmViewModel.IsBU(false);
                RmViewModel.BusinessUnitsList([]);
                GetAllOrganizationalLevels().then(function () {

                    for (var i = 0; i < RmViewModel.OrgLvlDrpDwnList().length; i++) {
                        if (RmViewModel.OrgLvlDrpDwnList()[i].BlId() == RmViewModel.SelectedOrgLevelId()) {
                            for (var j = 0; j < RmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                                mappedBuList.push(RmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j]);
                            }
                            RmViewModel.BusinessUnitsList(mappedBuList);
                            break;
                        }
                    }
                });
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in BuListReport() method in Report.js';
            logger.logMessage(msg);
        }
    }
    function GetAssessmentType() {
        try {
            return $.ajax({
                url: "/api/Configuration/GetAssessmentTypes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
            })
                .success(function (jsonResult, error) {
                    var MappedAssessmentModel = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAssessmentModel(result);
                        return RiskAreaModelObj;
                    });
                    RmViewModel.AssessmentList(MappedAssessmentModel);
                })
                .fail(function (jsonResult, error) { });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in Reports.js';
            logger.logMessage(msg);
        }
    }
    function RiskAssessmentModel(item) {

        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.RiskAssessmentName = ko.observable($('<div/>').html(item.AssessmentName).text());
            self.RiskAssessmentType = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.RiskAssessmentDescription = ko.observable($('<div/>').html(item.Description).text());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAssessmentModel() method in Reports.js';
            logger.logMessage(msg);
        }
    }

    function FillSubOrgLevel() {
        GetBusinessUnitByBusinessLevel();
    }
    function GetBusinessUnitByBusinessLevel() {
        try {
            return $.ajax({
                url: "/api/Reporting/GetAllBusinessUnitsByBusinessLevel?profileId=" + RmViewModel.SelectedProfileOfAssessmentS01(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in report.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResultObj, status) {

            try {

                if (jsonResultObj != 'undefined' && jsonResultObj != null && jsonResultObj != "") {

                    RmViewModel.BusinessUnitsList([]);
                    var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                        return new BusinessUnitsModel(result);
                    });

                    RmViewModel.BusinessUnitsList(mappedBusinessUnits);

                    $('#BUSelector').multiselect();
                    $('#BUSelector').multiselect("refresh");
                    $(".ui-multiselect-checkboxes > li > label > span").addClass("cc-facet-result-text tag-text");

                    //$(".ui-multiselect-checkboxes > li > label").addClass("cc-checkbox");
                    //  $(".ui-multiselect-checkboxes > li > label > span").addClass("cc-facet-result-text tag-text");
                }
                else {
                    RmViewModel.BusinessUnitsList([]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllBusinessUnits() method in ValidationReports.js';
                logger.logMessage(msg);
            }

        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in ValidationReports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        };
    }

    function BusinessUnitsModel(item) {
        try {
            var self = this;
            self.BlvalueId = ko.observable(item.BU_ID);
            self.BlvalueName = ko.observable($('<div/>').html(item.businessUnitCleanName).text());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in WordReport.js';
            logger.logMessage(msg);
        }
    }

    function OpenDownloadSummaryReportpopup(data, event) {
        try {
            var a = 0;
            getProfileOfAssessmentDetails();
            GetAssessmentType();
            RmViewModel.AppliacbleAssessmentList = data.applicableAssessmentTypes;
            ko.cleanNode(document.getElementById('AssessmentType'));
            ko.applyBindings(RmViewModel, document.getElementById("AssessmentType"));
            RmViewModel.popUpTitle("Download  Report");
            $('#frmSummaryReportS01').modal('show');
            $('#modalContent').css({
                'margin-top': '25%'
            });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenDownloadSummaryReportpopup() method in Reports.js';
            logger.logMessage(msg);
        }
    }
    

    function OpenDownloadSummaryReportpopupS02(data, event) {
        try {
            var a = 0;
            getProfileOfAssessmentDetails();
            GetAssessmentType();
            RmViewModel.AppliacbleAssessmentList = data.applicableAssessmentTypes;
            ko.cleanNode(document.getElementById('AssessmentType'));
            ko.applyBindings(RmViewModel, document.getElementById("AssessmentType"));
            RmViewModel.popUpTitle("Download Report");
            $('#frmSummaryReportS02').modal('show');
            $('#modalContent').css({
                'margin-top': '25%'
            });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenDownloadSummaryReportpopupS02() method in Reports.js';
            logger.logMessage(msg);
        }
    }
    function DownloadWordReport(data, event) {
        try {
            RmViewModel.SelSubOrgShortName = $('#BUSubOrg option:selected').text();
            RmViewModel.SelSubOrgName = $('#BUSubOrg option:selected').text();
            RmViewModel.SelRiskAssessmentName = $('#AssessmentType option:selected').text();
            var c = RmViewModel.SelectedProfileHistoricalAssessment;
            var OrgId = RmViewModel.SelectedOrgLevelId();
            if (RmViewModel.SelRiskAssessmentName == "Fair Lending") {
                var payLoad = {
                    //t: appsecurity.getAuthenticationInfo(), FilePath: data.DocPath().substring(data.DocPath().lastIndexOf('}'), 0), Profile: Profile, DocType: DocType, FileName: data.DocumentName()
                    t: appsecurity.getAuthenticationInfo(), json: JSON.stringify($.map(RmViewModel.SelectedBuUnitsID(), function (result) { return { BuId: result }; })), YOA: RmViewModel.SelectedProfileOfAssessmentS01(), OrglevelId: RmViewModel.SelectedOrgLevelId(), AssessmentId: RmViewModel.SelectedAssessmentId(), SubOrgName: RmViewModel.SelSubOrgName, SubOrgShortName: RmViewModel.SelSubOrgShortName, AssessmentName: RmViewModel.SelRiskAssessmentName, HistoricalProfile: RmViewModel.SelectedProfileHistoricalAssessment()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadReportFL", payLoad, '_blank');
            }
            else if (RmViewModel.SelRiskAssessmentName == "Bank Secrecy Act / Anti-Money Laundering") {
                var payLoadAMLOFAC = {
                    t: appsecurity.getAuthenticationInfo(), json: JSON.stringify($.map(RmViewModel.SelectedBuUnitsID(), function (result) { return { BuId: result }; })), YOA: RmViewModel.SelectedProfileOfAssessmentS01(), OrglevelId: RmViewModel.SelectedOrgLevelId(), AssessmentId: RmViewModel.SelectedAssessmentId(), SubOrgName: RmViewModel.SelSubOrgName, SubOrgShortName: RmViewModel.SelSubOrgShortName, AssessmentName: RmViewModel.SelRiskAssessmentName, HistoricalProfile: RmViewModel.SelectedProfileHistoricalAssessment()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadReportAMLOFAC", payLoadAMLOFAC, '_blank');
            }
            else if (RmViewModel.SelRiskAssessmentName == "Anti-Bribery/Anti-Corruption") {
                var payLoadABAC = {
                    //t: appsecurity.getAuthenticationInfo(), FilePath: data.DocPath().substring(data.DocPath().lastIndexOf('}'), 0), Profile: Profile, DocType: DocType, FileName: data.DocumentName()
                    t: appsecurity.getAuthenticationInfo(), json: JSON.stringify($.map(RmViewModel.SelectedBuUnitsID(), function (result) { return { BuId: result }; })), YOA: RmViewModel.SelectedProfileOfAssessmentS01(), OrglevelId: RmViewModel.SelectedOrgLevelId(), AssessmentId: RmViewModel.SelectedAssessmentId(), SubOrgName: RmViewModel.SelSubOrgName, SubOrgShortName: RmViewModel.SelSubOrgShortName, AssessmentName: RmViewModel.SelRiskAssessmentName, HistoricalProfile: RmViewModel.SelectedProfileHistoricalAssessment()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadReportABAC", payLoadABAC, '_blank');
            }


            else if (RmViewModel.SelRiskAssessmentName == "UDAP-UDAAP") {
                var payLoadUDAAP = {
                    //t: appsecurity.getAuthenticationInfo(), FilePath: data.DocPath().substring(data.DocPath().lastIndexOf('}'), 0), Profile: Profile, DocType: DocType, FileName: data.DocumentName()
                    t: appsecurity.getAuthenticationInfo(), json: JSON.stringify($.map(RmViewModel.SelectedBuUnitsID(), function (result) { return { BuId: result }; })), YOA: RmViewModel.SelectedProfileOfAssessmentS01(), OrglevelId: RmViewModel.SelectedOrgLevelId(), AssessmentId: RmViewModel.SelectedAssessmentId(), SubOrgName: RmViewModel.SelSubOrgName, SubOrgShortName: RmViewModel.SelSubOrgShortName, AssessmentName: RmViewModel.SelRiskAssessmentName, HistoricalProfile: RmViewModel.SelectedProfileHistoricalAssessment()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadReportUDAAP", payLoadUDAAP, '_blank');
            }

            else if (RmViewModel.SelRiskAssessmentName == "Office of Foreign Assets Control") {
                var payLoadOFAC = {
                    t: appsecurity.getAuthenticationInfo(), json: JSON.stringify($.map(RmViewModel.SelectedBuUnitsID(), function (result) { return { BuId: result }; })), YOA: RmViewModel.SelectedProfileOfAssessmentS01(), OrglevelId: RmViewModel.SelectedOrgLevelId(), AssessmentId: RmViewModel.SelectedAssessmentId(), SubOrgName: RmViewModel.SelSubOrgName, SubOrgShortName: RmViewModel.SelSubOrgShortName, AssessmentName: RmViewModel.SelRiskAssessmentName, HistoricalProfile: RmViewModel.SelectedProfileHistoricalAssessment()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadReportAMLOFAC", payLoadOFAC, '_blank');
            }
            else if (RmViewModel.SelRiskAssessmentName == "Regulatory Compliance") {
                var payLoadFL = {
                    //t: appsecurity.getAuthenticationInfo(), FilePath: data.DocPath().substring(data.DocPath().lastIndexOf('}'), 0), Profile: Profile, DocType: DocType, FileName: data.DocumentName()
                    t: appsecurity.getAuthenticationInfo(), json: JSON.stringify($.map(RmViewModel.SelectedBuUnitsID(), function (result) { return { BuId: result }; })), YOA: RmViewModel.SelectedProfileOfAssessmentS01(), OrglevelId: RmViewModel.SelectedOrgLevelId(), AssessmentId: RmViewModel.SelectedAssessmentId(), SubOrgName: RmViewModel.SelSubOrgName, SubOrgShortName: RmViewModel.SelSubOrgShortName, AssessmentName: RmViewModel.SelRiskAssessmentName, HistoricalProfile: RmViewModel.SelectedProfileHistoricalAssessment()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadReportReg", payLoadFL, '_blank');
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DownloadReport() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }


    function DownloadReport(data, event) {
        try {
            var BuId = RmViewModel.SelectedBuUnitsID();
            var selectedBuId = RmViewModel.SelectedBuUnitsID()[0];
            for (var i = 0; i < RmViewModel.BusinessUnitsList().length; i++)
            {
                if (selectedBuId == RmViewModel.BusinessUnitsList()[i].BlvalueId())
                    var shortname = RmViewModel.BusinessUnitsList()[i].BlvalueName(); 
            }
            var FlagAML = 1;
            if (RmViewModel.AssessmentList()[0].RiskAssessmentName().toString() === "OFAC") {
                FlagAML = 0;
            }
            else {
                FlagAML = 1;
            }
            var payLoad = {

                t: appsecurity.getAuthenticationInfo(), json: JSON.stringify($.map(RmViewModel.SelectedBuUnitsID(), function (result) { return { BuId: result }; })), SubOrgId: BuId[0], YOA: RmViewModel.SelectedProfileOfAssessmentS02(), OrglevelId: RmViewModel.SelectedOrgLevelId(), AssessmentId: RmViewModel.SelectedAssessmentId(), ShowOverrides: RmViewModel.Overrides_Show(), SubOrgName: RmViewModel.SelSubOrgName, SubOrgShortName: shortname
                , FAML: FlagAML
            };
            utils.postAndRedirect(rootPath + "/FileDownload/DownloadReportS02", payLoad, '_blank');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DownloadReport() method in Reports.js';
            logger.logMessage(msg);
        }
    }


    function YearChanged(data, event) {
        try {
            if (event.target.value.length == 4 && !isNaN(event.target.value) && event.target.value.indexOf(' ') == -1) {
                document.getElementById("valfactorerror").innerHTML = "";
                $(valfactorerror).hide();
                RmViewModel.Savedisabled(true);
            }
            else {
                $(valfactorerror).show();

                document.getElementById("valfactorerror").innerHTML = "Please enter valid Year of Assessment";
                RmViewModel.Savedisabled(false);
            }
            //getleveloptions();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: YearChanged() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function getS01ReportDetails() {
        try {
            try {

                $.ajax({
                    url: "/api/Reporting/GetWordReportDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getS01ReportDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {

                    RmViewModel.SrNo(0);
                    if (jsonResult != null) {
                        RmViewModel.SrNo(0);
                        var mappedUserDetails = $.map(jsonResult, function (result) {
                            return new ReportDetailsModel(result);
                        });
                        tableObj = $('#tblReportDetailsS01').DataTable();
                        tableObj.destroy();
                        $('#tblReportDetailsS01 tbody tr').remove();
                        QuestionTableObj = undefined;
                        RmViewModel.ReportDetailsList([]);
                        RmViewModel.ReportDetailsList(mappedUserDetails);
                        QuestionTableObj = $('#tblReportDetailsS01').DataTable({
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": true,
                                "bSortable": true

                            },
                            {
                                "aTargets": [1],
                                "bVisible": true,
                                "bSortable": false

                            },
                            {
                                "aTargets": [2],
                                "bSortable": true
                            }
                                , {
                                "aTargets": [3],
                                "bSortable": false,
                                "sClass": "text-center"

                            }]

                        });

                        $('#tblQualQuestions').DataTable().draw(false);
                    }
                    else {
                        logger.logError('An error occured while fetching the Narrative Reports for this client.', 'Error', system.getModuleId(RmViewModel), true);
                        $("#tblReportDetailsS01").hide();
                        $("#tblReportDetailsS02").hide();
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getS01ReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getS01ReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getS01ReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getS01ReportDetails() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function getProfileOfAssessmentDetails() {
        try {

            $.ajax({
                url: "/api/Calculation/GetProfileAssessmentData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getProfileOfAssessmentDetails() method in ReportManagement.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.length > 0) {
                    var MappedYearofAssessment = $.map(jsonResult, function (result) {
                        return new ProfileofAssessmentModel(result);
                    });
                    RmViewModel.ProfileofAssessmentList([]);
                    RmViewModel.ProfileofAssessmentList(MappedYearofAssessment);
                }
                else
                    logger.logError('An error occurred while fetching the Assessment Profiles. Please contact your application administrator.', 'Error', system.getModuleId(RmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from getProfileOfAssessmentDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                var msg = 'Exception: ' + error + ' | Source: ajaxSuccess from getProfileOfAssessmentDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from getProfileOfAssessmentDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

    }

    function ClickUploaddocument() {
        try {
            var NewDataObj = new ReportDetailsModel({ DocumentType: RmViewModel.valuedoctype(), DocumentUploadedforYear: RmViewModel.CurrentYear(), DocumentComments: "", DocumentPath: "" });
            RmViewModel.LowestOptionList([]);
            RmViewModel.LowestOptionSprocList([]);
            RmViewModel.DocumentTypeList([]);
            RmViewModel.DocumentTypeList(RmViewModel.DocumentTypeListDup())
            RmViewModel.EditDocumentDetails(NewDataObj);
            RmViewModel.popUpTitle("Upload Document");
            RmViewModel.addPopUpCss(true);
            $('#adddoc').modal('show');
            $('#modalContent').css({
                'margin-top': '25%'
            });
            setTimeout("$('#yearinput').focus();", 200);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClickUploaddocument() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function SaveDocument() {
        try {
            if (RmViewModel.EditDocumentDetails().DocComments() == undefined) {
                document.getElementById('valfactorerror').innerHTML = "Please enter comments.";
            }
            else {
                UploadDocument();
            }


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveDocument() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function getoptions() {
        try {
            try {
                $.ajax({
                    url: "/api/Calculation/Getdoctype",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getoptions() method in ReportManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult != null) {
                        var mappedUserDetails = $.map(jsonResult, function (result) {
                            return new Doctypes(result);
                        });
                        RmViewModel.DocumentTypeList(mappedUserDetails);
                        RmViewModel.DocumentTypeListDup(mappedUserDetails);
                    }
                    else
                        logger.logError('Some Error Occured while Fetching options', 'Error', system.getModuleId(RmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetActiveRoles() method in UserRole.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getoptions() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getoptions() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getoptions() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function EditReportPopUp(data, event) {
        try {
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EditReportPopUp() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function deleteReport(data) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/DeleteReport?DocId=" + data.DocId(),
                headers: headers,
                type: "POST"

            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteReport() method in ReportManagement.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult != null) {
                    if (jsonResult == 1) {
                        logger.logSuccess('Report Deleted sucessfully.', 'Success', system.getModuleId(RmViewModel), true);
                        getS01ReportDetails();
                    }
                    else {
                        logger.logError('Some Error Occured while Deleting Report', 'Error', system.getModuleId(RmViewModel), true);
                    }
                }
                else
                    logger.logError('Some Error Occured while Deleting Report', 'Error', system.getModuleId(RmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteReport() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteReport() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteReport() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        };

    }

    function DeleteReportPopUp(data, event) {
        try {
            try {
                app.showMessage('Are you sure you want to delete this Report?', 'Delete Report', ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            deleteReport(data, event);
                        }
                    });

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteReportPopUp() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DeleteReportPopUp() method in ReportManagement.js';
            logger.logMessage(msg);
        }


    }




    //file upload functionality
    function UploadDocument(data, event) {
        try {
            var FileList = document.getElementById('FileUploader').files;
            if (FileList.length > 0) {
                var FileName = document.getElementById('FileUploader').files[0].name;
                if ((FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PNG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'JPG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                        FileName.length).toUpperCase() == 'JPEG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                            FileName.length).toUpperCase() == 'DOCX' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                FileName.length).toUpperCase() == 'DOC' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                    FileName.length).toUpperCase() == 'XLS' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                        FileName.length).toUpperCase() == 'PDF' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                            FileName.length).toUpperCase() == 'XLSX' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                FileName.length).toUpperCase() == 'CSV' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                    FileName.length).toUpperCase() == 'TXT' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                        FileName.length).toUpperCase() == 'PPT' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                            FileName.length).toUpperCase() == 'PPTX') && (FileName.split('.').length - 1) == 1) {
                    if (FileList[0].size <= 1000000000) {

                        document.getElementById('valfactorerror').innerHTML = "";

                        var FormDataObj = new FormData();
                        FormDataObj.append("File1", FileList[0]);
                        var request = new XMLHttpRequest();

                        request.onreadystatechange = function () {
                            if (request.readyState == 1) {
                                document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                $('#valfactorerror').show();
                            }
                            else if (request.readyState == 4) {
                                if (request.status == 200) {
                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                        document.getElementById('valfactorerror').innerHTML = "File has been uploaded successfully.";
                                        $('#valfactorerror').show();
                                        UploadReportDetails(JSON.parse(request.response));
                                        var DocName = document.getElementById('FileUploader').files[0].name;
                                        document.getElementById('FileUploader').value = null;
                                        // SetComments(data.QuestionId(), "RD", "", DocName, JSON.parse(request.response), SrViewModel.UploadComment());
                                        $('#adddoc').modal('hide');
                                        $('body').removeClass('modal-open');
                                        $('.modal-backdrop').remove();
                                    }
                                    else {
                                        document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                        $('#valfactorerror').show();
                                        document.getElementById('FileUploader').value = null;
                                    }
                                }
                                else
                                    ajaxFail(request, "");
                            }
                        };
                        request.upload.addEventListener('progress', function (event) {
                            //SrViewModel.ProgressPercent(parseInt((event.loaded / event.total) * 100) + '%');
                            //SrViewModel.ProgressMessage("Uploading File...");
                            document.getElementById('valfactorerror').innerHTML = "Uploading File...";

                        });
                        request.withCredentials = true;
                        for (var i = 0; i < RmViewModel.DocumentTypeList().length; i++) {
                            if (RmViewModel.DocumentTypeList()[i].DocCode() == RmViewModel.valuedoctype()) {
                                RmViewModel.FolderName(RmViewModel.DocumentTypeList()[i].DocType());
                                break;
                            }
                        }
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        request.open('POST', '/api/Calculation/FileUpload?profileofassessment=' + RmViewModel.CurrentProfile() + "&Doctype=" + RmViewModel.FolderName());
                        request.setRequestHeader('Authorization', headers.Authorization);
                        request.setRequestHeader('RT', headers.RT);
                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                        request.send(FormDataObj);

                    }
                    else {
                        //document.getElementById('valfactorerror').innerHTML = "Upload File Size cannot exceed " + (RmViewModel.UploadFileSize() / 1000000000) + " GB. Please Try Uploading a file of lesser size.";
                        document.getElementById('valfactorerror').innerHTML = "Upload File Size cannot exceed 1 GB. Please Try Uploading a file of lesser size.";
                        $('#valfactorerror').show();
                    }
                }
                else {
                    document.getElementById('valfactorerror').innerHTML = "Please Select Valid File to Upload";
                    $('#valfactorerror').show();
                }
            }
            else {
                document.getElementById('valfactorerror').innerHTML = "Please Select a File to Upload";
                $('#valfactorerror').show();
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {

                                }
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocument() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocument() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in ReportManagement.js';
            logger.logMessage(msg);
        }

    }

    function UploadReportDetails(docpath) {
        try {
            var DocumnentName = docpath.substring(docpath.lastIndexOf('}') + 1, docpath.length)
            // RmViewModel.EditDocumentDetails().DocPath(docpath)
            RmViewModel.docpath(docpath);
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Calculation/UploadReportDetails?profile=" + RmViewModel.CurrentProfile() + "&docname=" + DocumnentName + "&docpath=" + RmViewModel.docpath() + "&type=" + $("#AmlDrpDwn option:selected").val() + "&comments=" + RmViewModel.EditDocumentDetails().DocComments(),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in UploadReportDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult == 1) {
                            logger.logSuccess('Report Uploaded Successfully.', 'Success', system.getModuleId(RmViewModel), true);
                            getS01ReportDetails();

                        }
                    }
                    else
                        logger.logError('Some Error Occured while Uploading Report', 'Error', system.getModuleId(RmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UploadReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UploadReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UploadReportDetails() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }
    //file upload functionality ends

    //model definition starts here
    function Doctypes(item) {
        try {
            var self = this;
            self.DocType = ko.observable($('<div/>').html(item.Doctype).text());
            self.DocCode = ko.observable($('<div/>').html(item.Type).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Doctypes() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function ReportDetailsModel(item) {

        try {
            var self = this;
            RmViewModel.SrNo(RmViewModel.SrNo() + 1);
            self.SrNo = ko.observable(RmViewModel.SrNo());
            self.DocId = ko.observable($('<div/>').html(item.DocumentId).text());
            self.DocumentUploadedforProfile = ko.observable($('<div/>').html(item.DocumentUploadedforProfile).text());
            self.DocumentName = ko.observable($('<div/>').html(item.DocumentName).text());
            self.DocumentUploadedforProfile = ko.observable($('<div/>').html(item.DocumentUploadedforProfile).text());

            self.DocumentDescription = ko.observable($('<div/>').html(item.DocumentDescription).text());

            self.applicableAssessmentTypes = $.map(item.ApplicableAssessmentTypes, function (result) {
                return new RiskAssessmentModel(result);
            });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ReportDetailsModel() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }


    //Model to Store the Profileofassessmentdetails
    function ProfileofAssessmentModel(item) {
        try {
            var self = this;
            self.ConfigurationFreezeFlag = ko.observable('true');
            self.Fromdate = ko.observable($('<div/>').html(item.Fromdate).text());
            self.Todate = ko.observable($('<div/>').html(item.Todate).text());
            self.ProfileId = ko.observable($('<div/>').html(item.ProfileId).text());
            self.Profilename = ko.observable($('<div/>').html(item.Profilename).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ProfileofAssessmentModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    //------------------------------------------------------------------------Logic to Fetch User Details and List of All Roles Starts Here----------------------------------------------



    //------------------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------------

});
